// extracted by mini-css-extract-plugin
module.exports = {"section":"Payout-section_85ad9d0a","title":"Payout-title_3ecd507b","desc":"Payout-desc_b97753f9","row":"Payout-row_01f00e2f"};